import Vue from 'vue'
import { index, show, update, store } from '../../services/blogs/blogs'

export const blogs = {

  namespaced: 'blogs',

  state: {
    data: {},
    pagination: {},
    loading: true,
    error: null
  },

  actions: {

    index ({ state, commit }, data) {
      index(data.page, data.search, data.filter)
        .then(response => {
          commit('setData', response.data)
          commit('setPagination', response.data)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    storeBlog ({ state, commit }, data) {
      commit('setLoading', true)
      store(data)
        .then(response => {
          commit('setLoading', false)
          Vue.toasted.success('Blog salvo com sucesso!')
          window.location.href = '/articles'
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao cadastrar a categoria!')
        })
    },

    showBlog ({ state, commit }, id) {
      show(id)
        .then(response => {
          commit('setData', response.data)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    updateBlog ({ state, commit }, data) {
      update(data.id, data)
        .then(response => {
          commit('setData', response.data)
          commit('setLoading', false)
          Vue.toasted.success('Blog atualizado com sucesso!')
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar blog!')
        })
    }
  },

  mutations: {

    setData (state, blogs) {
      state.data = blogs
    },

    setPagination (state, paginate) {
      state.pagination = paginate
    },

    setLoading (state, status) {
      state.loading = status
    },

    setError (state, error) {
      if (error.status === 401) {
        localStorage.clear()
        window.location.href = './login'
      }
    }

  },

  getters: {}

}
